import { render, staticRenderFns } from "./ScheduleTemplates.vue?vue&type=template&id=540635a3&scoped=true"
import script from "./ScheduleTemplates.vue?vue&type=script&lang=js"
export * from "./ScheduleTemplates.vue?vue&type=script&lang=js"
import style0 from "./ScheduleTemplates.vue?vue&type=style&index=0&id=540635a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540635a3",
  null
  
)

export default component.exports